import { plural } from '@cian/utils';

export const formatFloors = (floorCount: number | undefined) => {
  if (!floorCount) {
    return;
  }

  return `${floorCount} ` + plural(floorCount, ['этаж', 'этажа', 'этажей']);
};
